import { Helper } from "./helper";
import { Config } from "../config/config";

export class ReportingHelper {
    public static create = () => {
        return function () {
            let visibleQuestionCount = 0;
            let answeredQuestionCount = 0;
            const tools = {
                createDataSource: function (questionPossibleAnswers, filterFunctionCode, reportAnswers, entityForScript) {
                    let result: { text: any, value: any }[] = [];
                    if (Array.isArray(questionPossibleAnswers)) {
                        for (let i = 0; i < questionPossibleAnswers.length; i++) {
                            result.push({
                                text: questionPossibleAnswers[i].Text,
                                value: questionPossibleAnswers[i].Code
                            });
                        }
                    }
                    if (filterFunctionCode) {
                        try {
                            const filterFunction = new Function("answers", "id", filterFunctionCode);
                            result = result.filter((value) => {
                                try {
                                    return filterFunction(entityForScript, value.value)
                                } catch (e) {
                                    return true;
                                }

                            });
                        } catch (e) {
                            console.log(e);
                        }

                    }
                    return result;
                },
                executeFunction: function (functionCode: string, entityForScript, sectionVisible: boolean) {
                    const func = new Function("answers", functionCode)
                    const result = func(entityForScript) && (Helper.hasValue(sectionVisible) ? sectionVisible : true);
                    return result == null ? true : result;
                },
                getCorrespondingDirective: function (questionItem, translations, sectionVisible: boolean, enableEditorModus: boolean, entity, entityForScript, cachedDocs: any[], reportId: string, api, javaScriptFunctions) {
                    const qRefName = questionItem.UniqueName || questionItem.Id; //unique per report               

                    questionItem._guid = questionItem._guid || kendo.guid();

                    const visibilityFunction = (questionItem.VisibilityPredicate != null ? questionItem.VisibilityPredicate : "return true;");
                    const overridenText = getTranslatedText(questionItem.TranslatableOverriddenText);
                    const overriddenRemark = getTranslatedText(questionItem.TranslatableOverriddenRemark);
                    let constraintViolations = [];
                    let visible = true;
                    try {
                        visible = this.executeFunction(visibilityFunction, entityForScript, sectionVisible)
                        if (visible) {
                            visibleQuestionCount++;
                        }
                        const value = entity[qRefName];
                        if (visible && Helper.hasValue(value) && value !== "") {
                            answeredQuestionCount++;
                        }
                        constraintViolations = evaluateConstraints(questionItem.Constraints, entity[qRefName], questionItem.Type, entity, translations, entityForScript, javaScriptFunctions, qRefName);
                    } catch (e) {
                        constraintViolations = [{ Message: translations["CUSTOM_REPORT_SCRIPT_CRASHED"], Severity: Severity.Error }];
                        console.error(e);
                    }
                    let result = {
                        guid: questionItem._guid,
                        model: "entity." + qRefName,
                        visible: visible,
                        visibleCondition: null,
                        required: false,
                        readOnly: false,
                        name: overridenText ? overridenText : getTranslatedText(questionItem.TranslatableQuestionText),
                        remark: overriddenRemark ? overriddenRemark : getTranslatedText(questionItem.TranslatableRemark),
                        type: null,
                        labelLabelStyle: { whiteSpace: "pre-line", height: "initial", overflow: "initial" },
                        constraintViolations: constraintViolations,
                        allowDocuments: questionItem.AllowDocuments,
                        refreshDSOnRefChange: true
                    };

                    let dataSource = {};

                    switch (questionItem.Type) {
                        case 1:
                            result.type = "is-numeric-text-box";
                            result["spinners"] = true;
                            result["decimals"] = 0;
                            result["format"] = "#";
                            result["modelUnity"] = "\"\"";
                            break;
                        case 2:
                            result.type = "is-numeric-text-box";
                            result["spinners"] = true;
                            result["decimals"] = 4;
                            result["format"] = "#.####";
                            result["modelUnity"] = "\"\"";
                            break;
                        case 3:
                            result.type = "checkbox";
                            break;
                        case 4:
                            result.type = "textbox";
                            result["multiLine"] = true;
                            break;
                        case 5:
                            result.type = "is-multiple-radio-buttons";
                            result["dataTextField"] = "text";
                            result["dataValueField"] = "value";
                            result["dataSource"] = qRefName + "_ds";
                            dataSource["name"] = qRefName + "_ds";
                            result["refreshDSOnRefChange"] = true;
                            dataSource["data"] = tools.createDataSource(questionItem.AnswerReferences, questionItem.FilterScript, entity, entityForScript);
                            break;
                        case 11:
                            result.type = "kendo-drop-down-list";
                            result["optionLabel"] = translations["Standard.BitteWählen"];
                            result["dataTextField"] = "text";
                            result["dataValueField"] = "value";
                            result["dataSource"] = /*"dataSources." + */qRefName + "_ds";
                            dataSource["name"] = qRefName + "_ds";
                            result["refreshDSOnRefChange"] = true;
                            dataSource["data"] = tools.createDataSource(questionItem.AnswerReferences, questionItem.FilterScript, entity, entityForScript);
                            break;
                        case 6:
                            result.type = "is-multiple-check-boxes";
                            result["dataTextField"] = "text";
                            result["dataValueField"] = "value";
                            result["dataSource"] = /*"dataSources." +*/ qRefName + "_ds";
                            result["primitiveValue"] = true;
                            //result["readOnly"] = enableEditorModus;
                            result["refreshDSOnRefChange"] = true;
                            dataSource["name"] = qRefName + "_ds";
                            dataSource["data"] = tools.createDataSource(questionItem.AnswerReferences, questionItem.FilterScript, entity, entityForScript);
                            break;
                        case 8:
                            result.type = "kendo-date-picker";
                            break;
                        case 9:
                            result.type = "kendo-time-picker";
                            break;
                        case 12:
                            result.type = "dynamic";
                            result["moduleName"] = "app/statistics/service_report/service_report_editor";
                            result["appName"] = "StaticImage";
                            result["pictures"] = questionItem.Pictures;
                            result["labelAndControlCombined"] = true;
                            result["cachedDocs"] = cachedDocs;
                            break;
                        case 13:
                            if (api) {
                                api.answers = entityForScript;
                            }
                            result.type = "dynamic";
                            result["moduleName"] = "app/statistics/service_report/service_report_editor";
                            result["appName"] = "ReactTemplateComponent";
                            result["transpiledCode"] = questionItem.ReactTemplate ? questionItem.ReactTemplate.transpiledCode : null;
                            result["reportId"] = reportId;
                            result["api"] = api;
                            break;
                        case 0:
                        default:
                            result.type = "textbox";
                            break;
                    }


                    if (Helper.hasValue(questionItem.Unit)) {
                        let chars = !Helper.isNullOrEmpty(questionItem.Unit.DisplayChars) ? `"${questionItem.Unit.DisplayChars}"` : "";
                        let name = !Helper.isNullOrEmpty(questionItem.Unit.DisplayName) ? `"${questionItem.Unit.DisplayName}"` : "";
                        if (Helper.isNullOrEmpty(chars)) {
                            chars = name
                        }
                        result["modelUnity"] = chars;
                        result["modelUnityTitle"] = name;
                    }


                    return { item: result, dataSource: dataSource };
                },
                getSize: function (width, rowSize = 1) {
                    return [
                        {
                            "container": "extrasmall",
                            "width": `${12}/12`,
                            "rowSize": rowSize
                        },
                        {
                            "container": "small",
                            "width": `${12}/12`,
                            "rowSize": rowSize
                        },
                        {
                            "container": "medium",
                            "width": `${width}/12`,
                            "rowSize": rowSize
                        },
                        {
                            "container": "large",
                            "width": `${width}/12`,
                            "rowSize": rowSize
                        },
                        {
                            "container": "extralarge",
                            "width": `${width}/12`,
                            "rowSize": rowSize
                        }
                    ];

                },
                getEntityForScripts: function (sections, entity) {
                    let typeInfo = "{\n";
                    if (!Array.isArray(sections)) {
                        return {};
                    }
                    const newEntity = {};
                    for (const s of sections || []) {
                        for (const q of s.Questions || []) {
                            const name = q.UniqueName || q.Id;
                            switch (q.Type) {
                                case 1:
                                case 2:
                                    if (entity[name]) {
                                        newEntity[name] = typeof entity[name] == "string" ? Number(entity[name]) : entity[name];
                                    }
                                    else {
                                        newEntity[name] = null;
                                    }
                                    typeInfo += "'" + name + "':number|null,\n"
                                    break;
                                case 3:
                                    if (entity[name] && typeof entity[name] == "string") {
                                        newEntity[name] = entity[name] == "True" ? true : false;
                                    }
                                    else {
                                        newEntity[name] = Helper.hasValue(entity[name]) ? entity[name] : null;
                                    }
                                    typeInfo += "'" + name + "':boolean|null,\n"
                                    break
                                case 0:
                                case 4:
                                    newEntity[name] = entity[name] || null;
                                    typeInfo += "'" + name + "':string,\n"
                                    break;
                                case 9:
                                case 8:
                                    if (entity[name]) {
                                        const date = typeof entity[name] == "string" ? kendo.parseDate(entity[name]) : entity[name];
                                        const now_utc = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

                                        newEntity[name] = now_utc;
                                    }
                                    else {
                                        newEntity[name] = null;
                                    }
                                    typeInfo += "'" + name + "':Date,\n"
                                    break;
                                case 5:
                                case 11:
                                    const answerObj = {};
                                    typeInfo += "'" + name + "'" + ":{\n";
                                    typeInfo += "_selectedValue:any,\n";
                                    for (const a1 of q.AnswerReferences) {
                                        typeInfo += "'" + a1.Code + "'" + ":{selected:boolean,value:any},";
                                        const isSelected = entity[name] == a1.Code;
                                        const value = this.getVariantValue(a1.Value);
                                        answerObj[a1.Code] = { selected: isSelected, value: value };
                                        if (isSelected) {
                                            answerObj["_selectedValue"] = value;
                                        }
                                    }
                                    Object.defineProperty(answerObj, "_selectedValue", { enumerable: false })
                                    Object.freeze(answerObj);
                                    typeInfo += "}\n"
                                    newEntity[name] = answerObj;
                                    break;
                                case 6://CheckGroup
                                    const answerObj2 = {};
                                    const answers: string[] = Array.isArray(entity[name]) ? entity[name] : [];
                                    const selectedValues: any[] = [];
                                    typeInfo += "'" + name + "'" + ":{\n"
                                    typeInfo += "_selectedValue:any[],\n";
                                    for (const a1 of q.AnswerReferences) {
                                        typeInfo += "'" + a1.Code + "'" + ":{selected:boolean,value:any},";
                                        const isSelected = answers.filter((v) => v == a1.Code).length == 1;
                                        const value = this.getVariantValue(a1.Value);
                                        answerObj2[a1.Code] = { selected: isSelected, value: value };
                                        if (isSelected) {
                                            selectedValues.push(value);
                                        }
                                    }
                                    answerObj2["_selectedValue"] = selectedValues;
                                    typeInfo += "}\n"

                                    Object.defineProperty(answerObj2, "_selectedValue", { enumerable: false })
                                    Object.freeze(answerObj2);
                                    newEntity[name] = answerObj2;
                                    break;
                                default:
                            }
                        }
                    }
                    typeInfo += "}"
                    return { entity: newEntity, typeInfo: typeInfo };
                },
                getVariantValue: function (value: { DataType: string, Value: string }) {
                    return value.Value;
                },
                createTreeMetaData: function (tree, treeMeta, translations, regionFields, dataSources, multiSelects, flatDirectives, multipleCheckBoxes, multipleRadioButtons, floats, dropDownLists, enableEditorModus: boolean, entity, cachedDocs: any[], reportId: string, api, javaScriptFunctions): { visibleQuestionCount: number, answeredQuestionCount: number } {
                    if (!tree) {
                        return;
                    }
                    visibleQuestionCount = 0;
                    answeredQuestionCount = 0;
                    const entityForScript = this.getEntityForScripts(tree, entity).entity;
                    for (let i = 0; i < tree.length; i++) {

                        const sectionField = {
                            model: "entity.none",
                            type: "dynamic",
                            moduleName: "app/statistics/service_report/service_report_editor",
                            appName: "SectionSeparator",
                            labelAndControlCombined: true,
                            title: getTranslatedText(tree[i].TranslatableTitle),
                            visible: true,
                            atlasNode: tree[i],
                            constraintViolations: [],
                            api: api
                        }
                        if (!tree[i]._guid) {
                            tree[i]._guid = kendo.guid();
                        }
                        let sectionVisible = true;
                        try {
                            sectionVisible = tools.executeFunction(tree[i].VisibilityPredicate, entityForScript, null)
                        } catch (e) {
                            console.error(e);
                            sectionField.constraintViolations = [{ Message: translations["CUSTOM_REPORT_SCRIPT_CRASHED"], Severity: Severity.Error }];
                        }
                        if (sectionVisible || enableEditorModus) {
                            regionFields.push({ title: tree[i].Title, fields: [sectionField], guid: tree[i]._guid, renderHeader: false, size: this.getSize(12), visible: sectionVisible });
                        }

                        const isCollapsed = tree[i]["_isCollapsed"];
                        if (tree[i].Questions && (!Helper.hasValue(isCollapsed) || isCollapsed == false)) {
                            for (let q = 0; q < tree[i].Questions.length; q++) {
                                const question = tree[i].Questions[q];
                                const width = !!question.Size ? question.Size : 1;
                                const rowSize = !!question.RowSize ? question.RowSize : 1;

                                const item = {
                                    text: question.Text,
                                    items: [],
                                    expanded: true,
                                    id: question.Id,
                                    image: Config.baseUrl + "Content/icons/document_new_lined_16_h.png",
                                    qType: question.Type
                                };
                                if (question.Type > -1) {
                                    const directive = tools.getCorrespondingDirective(question, translations, sectionVisible, enableEditorModus, entity, entityForScript, cachedDocs, reportId, api, javaScriptFunctions);
                                    const editorWrapper = {
                                        type: "dynamic",
                                        guid: directive.item.guid,
                                        wrappedField: directive.item,
                                        moduleName: "app/statistics/service_report/service_report_editor",
                                        appName: enableEditorModus ? "FieldWrapperEditUi" : "FieldWrapperInputValues",
                                        model: "entity.wrapped",
                                        required: directive.item.required,
                                        labelAndControlCombined: true,
                                        dataSource: directive.item["dataSource"],
                                        dataTextField: directive.item["dataTextField"],
                                        dataValueField: directive.item["dataValueField"],
                                        isSelected: question._isSelected,
                                        visible: true
                                    };
                                    const formItem = editorWrapper;

                                    regionFields.push({ title: "Region", fields: [formItem], visible: true, renderHeader: false, size: this.getSize(width, rowSize), guid: formItem["guid"], renderCollapsed: !enableEditorModus && !formItem.wrappedField.visible });
                                    if (question.BreakAfter) {
                                        regionFields.push({ guid: kendo.guid(), breakStart: "small" });
                                    }
                                    if (directive.dataSource && directive.dataSource["data"]) {
                                        dataSources.push(directive.dataSource);
                                    }
                                    if (directive.item.type === "kendo-multi-select") {
                                        multiSelects.push(directive.item.model);
                                    } else if (directive.item.type === "is-multiple-check-boxes") {
                                        multipleCheckBoxes.push(directive.item.model);
                                    } else if (directive.item.type === "is-multiple-radio-buttons") {
                                        multipleRadioButtons.push(directive.item.model);
                                    } else if (directive.item.type === "is-numeric-text-box" && question.Type === 2) {
                                        floats.push(directive.item.model);
                                    } else if (directive.item.type === "kendo-drop-down-list") {
                                        dropDownLists.push(directive.item.model);
                                    }
                                    flatDirectives.push(directive.item);
                                } else {
                                    item.image = Config.baseUrl + "Content/icons/folder_open_16.png";
                                }

                                if (question.Children) {
                                    tools.createTreeMetaData(question.Children, item.items, translations, regionFields, dataSources, multiSelects, flatDirectives, multipleCheckBoxes, multipleRadioButtons, floats, dropDownLists, enableEditorModus, entity, cachedDocs, reportId, api, javaScriptFunctions);
                                }

                                treeMeta.push(item);
                            }
                        }
                    }
                    return { visibleQuestionCount: visibleQuestionCount, answeredQuestionCount: answeredQuestionCount };
                }
            }

            //API
            return {
                getEntityForScripts(sections, entity) {
                    return tools.getEntityForScripts(sections, entity);
                },
                createMetaData(tree, translations, fields, entity, enableEditorModus: boolean, cachedDocs: any[], reportId: string, api, javaScriptFunctions: any) {
                    let treeMeta = [], dataSources = [], multiSelects = [], flatDirectives = [], multipleCheckBoxes = [], multipleRadioButtons = [], floats = [], dropDownLists = [];
                    const counts = tools.createTreeMetaData(tree, treeMeta, translations, fields, dataSources, multiSelects, flatDirectives, multipleCheckBoxes, multipleRadioButtons, floats, dropDownLists, enableEditorModus, entity, cachedDocs, reportId, api, javaScriptFunctions);

                    return { counts: counts, dataSources: dataSources, multiSelects: multiSelects, flat: flatDirectives, multipleCheckBoxes: multipleCheckBoxes, multipleRadioButtons: multipleRadioButtons, floats: floats, dropDownLists: dropDownLists, treeMeta: treeMeta };
                },
                mergeDedupe(arr) {
                    return [...new Set([].concat(...arr))];
                },
                convertEntity(cacheData) {
                    const result = {
                        ServiceReportId: cacheData.serviceReportId,
                        RecordId: cacheData.recordId,
                        ReportId: cacheData.reportId,
                        ReportIndex: cacheData.position,
                        Type: cacheData.type,
                        MachineNumber: cacheData.machine,
                        Answers: [],
                        PIndex: cacheData.pIndex,
                        Remark: cacheData.remark
                    };
                    const exclude = ["isnew", "iswatchable", "iswatched", "individualfields", "recordright", "machine", "_docs"];
                    const entityAndDocsKeys = [...new Set([...Object.keys(cacheData.entity), ...Object.keys(cacheData.entity["_Docs"])])];
                    for (let key of entityAndDocsKeys) {
                        if (exclude.indexOf(key.toLowerCase()) === -1) {
                            if ((Helper.hasValue(cacheData.entity[key]) || Helper.hasValue(cacheData.entity["_Docs"] ? cacheData.entity["_Docs"][key] : null)) && typeof cacheData.entity[key] !== "function") {
                                let value = null, add = false;

                                //multiselects
                                if (cacheData.entity[key] && Array.isArray(cacheData.entity[key])) {
                                    value = cacheData.entity[key];
                                    add = true;

                                } else if (Helper.hasValue(cacheData.entity[key]) && cacheData.entity[key].toString().trim() !== "") {
                                    //not an array => must have a single value (not null, not empty)
                                    value = [cacheData.entity[key]];
                                    add = true;
                                }

                                if (add || (cacheData.entity["_Docs"] && cacheData.entity["_Docs"][key])) {
                                    result.Answers.push({
                                        QuestionId: key,
                                        QuestionIndex: -1,
                                        Value: value,
                                        DocumentIds: cacheData.entity["_Docs"] ? cacheData.entity["_Docs"][key] : null
                                    });
                                }
                            }
                        }
                    }
                    return result;
                },
                mapData(entity, data, cacheData) {
                    entity.Machine = data.MachineNumber;
                    if (data && Array.isArray(data.Answers)) {
                        if (!entity["_Docs"]) {
                            entity["_Docs"] = {};
                        }
                        for (let i = 0; i < data.Answers.length; i++) {
                            if (data.Answers[i].Codes) {
                                let value = data.Answers[i].Codes[0];
                                const model = data.Answers[i].QuestionId;
                                entity["_Docs"][model] = data.Answers[i].DocuIds;

                                if (cacheData.multiSelects.indexOf("entity." + model) >= 0 || cacheData.multiCheckBoxes.indexOf("entity." + model) >= 0) {
                                    value = data.Answers[i].Codes;
                                } else if (cacheData.floats.indexOf("entity." + model) >= 0) {
                                    value = kendo.parseFloat(value, "en-US");
                                }
                                entity[model] = value;
                            }
                        }
                    }
                },
                setUpSelectAnswerRules(rules) {
                    const outRules = {};
                    for (let i = 0; i < rules.length; i++) {
                        //source question (FID1)
                        const source = rules[i];
                        const model = "entity.q" + source.SourceQuestionId;
                        const sourceValueLookup = {}, tQuestionIds = [];
                        for (let j = 0; j < source.Rules.length; j++) {
                            //target question (FID2)
                            const target = source.Rules[j];
                            tQuestionIds.push(target.TargetQuestionId);
                            for (var k = 0; k < target.SingleRules.length; k++) {
                                //source value (RCODE1)
                                const sourceValue = target.SingleRules[k];

                                if (!sourceValueLookup[sourceValue.SourceQuestionCode]) {
                                    sourceValueLookup[sourceValue.SourceQuestionCode] = {};
                                }
                                if (!sourceValueLookup[sourceValue.SourceQuestionCode][target.TargetQuestionId]) {
                                    sourceValueLookup[sourceValue.SourceQuestionCode][target.TargetQuestionId] = [];
                                }

                                for (var l = 0; l < sourceValue.TargetQuestionCodes.length; l++) {
                                    sourceValueLookup[sourceValue.SourceQuestionCode][target.TargetQuestionId].push(sourceValue.TargetQuestionCodes[l]);
                                }
                            }
                        }
                        outRules[model] = { source: source, sourceValueLookup: sourceValueLookup, tQuestionIds: tQuestionIds };
                    }
                    return outRules;
                }
            };
        }();
    }
}

export enum Severity {
    Warning = 0,
    CriticalWarning = 1,
    Error = 2
}

export interface ConstraintError {
    EnabledScript?: string
    Severity: Severity
    Message: string
}

interface RangeConstraint extends ConstraintError {
    Min: number
    MinInclusive: boolean
    Max: number
    MaxInclusive: boolean
}

interface StringLengthConstraint extends ConstraintError {
    MaxLength: number
}

interface PatternConstraint extends ConstraintError {
    Pattern: string
}

interface CustomConstraint extends ConstraintError {
    ValidationScript: string
}


const evaluateConstraints = (constraints: ConstraintError[], value, componentType: number, allValues: any, translations: any, entityForScript, javaScriptFunctions, qRefName): ConstraintError[] => {
    if (!constraints || constraints.length == 0) {
        return [];
    }
    const allErrors: ConstraintError[] = [];
    for (const constraint of constraints) {

        if (constraint.EnabledScript) {
            try {
                const func = Function("answers", "value", constraint.EnabledScript);
                if (!func(entityForScript, value)) {
                    continue;
                }
            } catch (e) {
                console.error(e);
                allErrors.push({ Message: translations["CUSTOM_REPORT_SCRIPT_CRASHED"], Severity: Severity.Error });
            }
        }

        try {
            evaluateConstraint(constraint, value, translations, allErrors, componentType, entityForScript, javaScriptFunctions, qRefName);
        } catch (e) {
            allErrors.push({ Message: translations["CUSTOM_REPORT_SCRIPT_CRASHED"], Severity: Severity.Error });
        }
    }
    return allErrors;
}

const getTranslatedText = (values) => {

    if (values) {
        const result = values.filter(v => v["Language"] == Config.user.languageId)
        if (result && result.length > 0) {
            return result[0]["Translation"]
        }
    }

    return "";
}

const evaluateMandatoryConstraint = (mandatoryConstraint: ConstraintError, value: any, componentType: number, translations: any) => {
    const errorMessage = getTranslatedText(mandatoryConstraint.Message) || translations["GLOBAL_MANDATORY_FIELD_EMPTY"];
    const error = { Message: errorMessage, Severity: mandatoryConstraint.Severity };
    if (!Helper.hasValue(value) || value == "") {
        return error;
    }

    if (componentType == 3 && value === false) {
        return error;
    }

    if (Array.isArray(value) && value.length == 0) {
        return error;
    }
}

const evaluateStringLengthConstraint = (stringLength: StringLengthConstraint, value: any, componentType: number, translations: any) => {
    let errorMessage: string = getTranslatedText(stringLength.Message) || translations["GLOBAL_MAX_CHAR_LENGTH_EXCEEDED"];
    errorMessage = errorMessage.replace("{{maxLength}}", (stringLength.MaxLength || 0).toString());
    const error = { Message: errorMessage, Severity: stringLength.Severity };
    if (Helper.hasValue(value) && value != "" && value.length > stringLength.MaxLength) {
        return error;
    }
}

const evaluateInvalidRangeConstraint = (rangeConstraint: RangeConstraint, value: any, translations: any): ConstraintError => {
    let errorMessage: string = getTranslatedText(rangeConstraint.Message) || translations["CUSTOM_REPORT_RANGE_VIOLATION"];
    if (Helper.isNumber(rangeConstraint.Min) && !Helper.isNumber(rangeConstraint.Max)) {
        errorMessage = getTranslatedText(rangeConstraint.Message) || translations["CUSTOM_REPORT_MAX_VALUE_VIOLATION"];
    } else if (!Helper.isNumber(rangeConstraint.Min) && Helper.isNumber(rangeConstraint.Max)) {
        errorMessage = getTranslatedText(rangeConstraint.Message) || translations["CUSTOM_REPORT_MIN_VALUE_VIOLATION"];
    }
    errorMessage = errorMessage.replace("{{from}}", (Helper.isNumber(rangeConstraint.Min) ? rangeConstraint.Min.toString() : "-∞").toString());
    errorMessage = errorMessage.replace("{{until}}", (Helper.isNumber(rangeConstraint.Max) ? rangeConstraint.Max.toString() : "∞").toString());
    errorMessage = errorMessage.replace("{{minValue}}", (Helper.isNumber(rangeConstraint.Max) ? rangeConstraint.Max.toString() : "∞").toString());
    errorMessage = errorMessage.replace("{{maxValue}}", (Helper.isNumber(rangeConstraint.Min) ? rangeConstraint.Min.toString() : "∞").toString());

    if (!Helper.isNumber(value)) {
        return null;
    }

    const numberValue = Number(value);

    if (!((Helper.hasValue(rangeConstraint.Min) && compareLess(rangeConstraint.Min, numberValue, !rangeConstraint.MinInclusive)) || (Helper.hasValue(rangeConstraint.Max) && compareGreater(rangeConstraint.Max, numberValue, !rangeConstraint.MaxInclusive)))) {
        return { Message: errorMessage, Severity: rangeConstraint.Severity };
    }

    return null;
}

const compareLess = (min: number, value: number, inclusive: boolean) => {
    if (inclusive) {
        return value <= min;
    }
    return value < min;
}

const compareGreater = (max: number, value: number, inclusive: boolean) => {
    if (inclusive) {
        return value >= max;
    }
    return value > max;
}

const evaluatePatternConstraint = (patternConstraint: PatternConstraint, value: any, componentType: number, translations: any) => {
    let errorMessage: string = getTranslatedText(patternConstraint.Message) || translations["CUSTOM_REPORT_REGEX_VIOLATION"];
    errorMessage = errorMessage.replace("{{regEx}}", patternConstraint.Pattern);
    const error = { Message: errorMessage, Severity: patternConstraint.Severity };
    if (Helper.hasValue(value) && value != "" && !new RegExp(patternConstraint.Pattern).test(value)) {
        return error;
    }
}

const evaluateCustomConstraint = (customConstraint: CustomConstraint, value: any, componentType: number, allValues: any, translations: any) => {
    let errorMessage: string = getTranslatedText(customConstraint.Message) || translations["CUSTOM_REPORT_SCRIPT_VIOLATION"];
    const error = { Message: errorMessage, Severity: customConstraint.Severity };

    try {
        if (Helper.hasValue(value) && customConstraint.ValidationScript && !new Function("answers", "value", customConstraint.ValidationScript)(allValues, value)) {
            return error;
        }
    } catch (ex) {
        console.error(ex);
        return { Message: translations["CUSTOM_REPORT_SCRIPT_CRASHED"], Severity: Severity.Error };
    }
}

const evaluateGenericConstraint = (genericConstraint, value: any, componentType: number, allValues: any, translations: any, constraintCode) => {
    let errorMessage: string = getTranslatedText(genericConstraint.Message) || translations["CUSTOM_REPORT_SCRIPT_VIOLATION"];
    const error = { Message: errorMessage, Severity: genericConstraint.Severity };
    const parameter = genericConstraint.toJSON ? genericConstraint.toJSON() : { ...genericConstraint };
    delete parameter["_Object_Type"];
    delete parameter["CustomScriptId"];

    try {
        if (Helper.hasValue(constraintCode) && constraintCode && !new Function("parameter", "currentAnswer", constraintCode)(parameter, value)) {
            return error;
        }
    } catch (ex) {
        console.error(ex);
        return { Message: translations["CUSTOM_REPORT_SCRIPT_CRASHED"], Severity: Severity.Error };
    }
}

function evaluateConstraint(constraint: ConstraintError, value: any, translations: any, allErrors: ConstraintError[], componentType: number, entityForScript: any, javaScriptFunctions, qRefName) {
    let result = null;
    if (constraint["_Object_Type"] == "InvalidRangeConstraint") {
        result = evaluateInvalidRangeConstraint(constraint as RangeConstraint, value, translations);
        if (result) {
            allErrors.push(result);
        }
    }
    else if (constraint["_Object_Type"] == "MandatoryConstraint") {
        result = evaluateMandatoryConstraint(constraint, value, componentType, translations);
        if (result) {
            allErrors.push(result);
        }
    }
    else if (constraint["_Object_Type"] == "StringLengthConstraint") {
        result = evaluateStringLengthConstraint(constraint as StringLengthConstraint, value, componentType, translations);
        if (result) {
            allErrors.push(result);
        }
    }
    else if (constraint["_Object_Type"] == "PatternConstraint") {
        result = evaluatePatternConstraint(constraint as PatternConstraint, value, componentType, translations);
        if (result) {
            allErrors.push(result);
        }
    }
    else if (constraint["_Object_Type"] == "CustomConstraint") {
        result = evaluateCustomConstraint(constraint as CustomConstraint, value, componentType, entityForScript, translations);
        if (result) {
            allErrors.push(result);
        }
    }
    else if (constraint["_Object_Type"] == "TriggerValueConstraint") {
        result = evaluateGenericConstraint(constraint as CustomConstraint, entityForScript[qRefName], componentType, entityForScript, translations, javaScriptFunctions[constraint["CustomScriptId"]]);
        if (result) {
            allErrors.push(result);
        }
    }
}
